import api from 'plugin/api';
import jsonToFormData from 'utils/json/toFormData';

/**
 *  @description 모선정보 목록 API
 */

async function motherVesselList(params) {
  const url = '/sfsh/motherVessel?sort=budat,desc&sort=preAnalsDt,desc';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 모선정보 상세 API
 */
async function motherVesselDetail(seq) {
  const url = `/sfsh/motherVessel/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 모선정보 수정 API
 */
async function motherVesselFormUpdate(seq, requestBody) {
  const url = `/sfsh/motherVessel/${seq}`;
  const formData = jsonToFormData(requestBody);

  const response = await api.put(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return response;
}

/**
 *  @description 모선정보 맵핑할 검사결과 목록 API
 */
async function mthVessMapList(params) {
  const url = '/sfsh/inspection/result/mthVessMap';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 첨부파일 다운로드
 */
async function requestFileDownload(seq) {
  const url = `/sfsh/fileAttach/selfInsp/${seq}`;
  return api.get(url, { responseType: 'arraybuffer' });
}

/**
 * @description 첨부 파일 삭제
 */
async function requestFileDelete(seq) {
  const url = `/sfsh/fileAttach/selfInsp/${seq}`;
  return api.delete(url);
}

export {
  motherVesselList,
  motherVesselDetail,
  motherVesselFormUpdate,
  mthVessMapList,
  requestFileDownload,
  requestFileDelete
};
